import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ValuesSection from './components/ValuesSection';
import TargetAudienceSection from './components/TargetAudienceSection';
import SolutionsSection from './components/SolutionsSection';
import ProcessSection from './components/ProcessSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <Hero />
      <ValuesSection />
      <TargetAudienceSection />
      <SolutionsSection />
      <ProcessSection />
      <Footer />
    </div>
  );
}

export default App;
